import { webApp } from "./telegram";

export const haptics = {
  tap: () => {
    try { webApp.HapticFeedback.impactOccurred("light"); } catch { /* noop in browser */ }
  },
  success: () => {
    try { webApp.HapticFeedback.notificationOccurred("success"); } catch { /* noop */ }
  },
  warning: () => {
    try { webApp.HapticFeedback.notificationOccurred("warning"); } catch { /* noop */ }
  },
  error: () => {
    try { webApp.HapticFeedback.notificationOccurred("error"); } catch { /* noop */ }
  },
};
